import { render, staticRenderFns } from "./citizenship_calculator.vue?vue&type=template&id=12dfc1a6&"
import script from "./citizenship_calculator.vue?vue&type=script&lang=js&"
export * from "./citizenship_calculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports